import { makeRequest } from 'utils/requestLogger';

// NOTE: This service checks to see if the user is currently in sandbox mode
// If so, we mock up a comment and put it in the state
// If not, we proceed and make an api call as normal

export default (comment, is_sandbox = false) => {
  if (is_sandbox) {
    return Promise.resolve({
      data: {
        ...comment,
        meta: {},
        comment_id: comment.response_to,
        user_id: '896f18ec-6fd1-41a5-a6e7-aacd1af91aca',
        user: {
          id: '896f18ec-6fd1-41a5-a6e7-aacd1af91aca',
          name: 'Professor McGonagall',
          avatar_url:
            'http://img4.wikia.nocookie.net/__cb20150810173547/harrypotter/images/f/f9/PromoHP1_Minerva_McGonagall_2.jpg',
        },
        id: Math.random().toString().slice(2, 11), // generate a fake id
        created_at: Date.now(),
        rewards: [],
        flagged_by: [],
        starred_by: [],
        children: [],
      },
    });
  } else {
    return makeRequest(
      'post',
      `/api/submissions/${comment.submission_id}/comments`,
      comment
    );
  }
};



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/comment/postComment.js